<p class="paragraph-2 text-center">{{ "TOKEN-REQUEST.DESTINATION" | translate }}</p>
<form [formGroup]="form">
    <nb-radio-group status="control" formControlName="type_sending">
        <nb-radio [value]="1">Email</nb-radio>
        <nb-radio [value]="2">SMS</nb-radio>
    </nb-radio-group>
</form>
<div class="mt-4">
    <button nbButton fullWidth status="success" [disabled]="form.invalid || loading" (click)="onRequestToken()">
        {{ "GENERAL.SEND" | translate }} <nb-icon icon="paper-plane-outline"></nb-icon>
    </button>
</div>
